import Vue from 'vue'
import Router from 'vue-router'
import UploadAssessment from '@/pages/UploadAssessment'
import Start from '@/pages/Start'
import Close from '@/pages/Close'
import AssessmentCompleted from '@/pages/AssessmentCompleted'
import AnswerAssessment from '@/pages/AnswerAssessment'
import StakeholderUnsubscribe from '@/pages/StakeholderUnsubscribe'
import Confirm from '@/pages/AssessmentConfirm'
import VendorAssessment from '@/pages/VendorAssessment'
import StakeholderQuestionnaire from '@/pages/StakeholderQuestionnaire'
import AssessmentPreview from '@/pages/QuestionnairePreview'
import VendorMaintenance from '@/pages/VendorMaintenance'
import StakeholderMaintenance from '@/pages/StakeholderMaintenance'
import AccessDenied from '@/pages/AccessDenied'
import CategoryMaintenance from '@/pages/CategoryMaintenance'
import VendorCategoryMaintenance from '@/pages/VendorCategoryMaintenance'
import VendorAssessmentResult from '@/pages/VendorAssessmentResult'
import StakeholderQuestionnaireResult from '@/pages/StakeholderQuestionnaireResult'
import QuestionnaireResultDetail from '@/pages/QuestionnaireResultDetail'
import Error404 from '@/pages/error/404'
import ErrorPage from '@/pages/error/Error'
import CoverPage from '@/pages/CoverPage'
import CleanCache from '@/pages/manager/ServerCacheManager'
import DictionaryMaintenance from '@/pages/manager/DictionaryMaintenance'
import EmailTemplateMaintenance from '@/pages/manager/EmailTemplateMaintenance'
import AdminUsersMaintenance from '@/pages/manager/AdminUsersMaintenance'
import RejectAccess from '@/pages/error/RejectAccess'
import NetworkError from '@/pages/error/NetworkError'
import RegionalAccountMaintenance from '@/pages/RegionalAccountMaintenance'
import MaintLogView from '@/pages/MaintLogView';
import ReportMaintenance from '@/pages/ReportMaintenance'

import Constant from '@/common/Constant';
import {verifyUserInfo} from '../services/login.service';

Vue.use(Router);

const routes = [
  {
    path: '/upload',
    name: 'UploadAssessment',
    component: UploadAssessment
  },
  {
    path: '/assessmentPreview',
    name: 'AssessmentPreview',
    component: AssessmentPreview
  },
  {
    path: '/confirm',
    name: 'Confirm',
    component: Confirm
  },
  {
    path: '/:userType/:answerAssessmentId/:keyCode',
    name: 'Start',
    component: Start
  },
  {
    path: '/answerAssessment',
    name: 'AnswerAssessment',
    component: AnswerAssessment
  },
  {
    path: '/assessmentCompleted',
    name: 'AssessmentCompleted',
    component: AssessmentCompleted
  },
  {
    path: '/vendorAssessment',
    name: 'VendorAssessment',
    component: VendorAssessment
  },
  {
    path: '/stakeholderQuestionnaire',
    name: 'StakeholderQuestionnaire',
    component: StakeholderQuestionnaire
  },
  {
    path: '/vendorMaintenance',
    name: 'VendorMaintenance',
    component: VendorMaintenance
  },
  {
    path: '/stakeholderMaintenance',
    name: 'StakeholderMaintenance',
    component: StakeholderMaintenance
  },
  {
    path: '/',
    name: 'AccessDenied',
    component: AccessDenied
  },
  {
    path: '/unsubscribe/Stakeholder/:answerAssessmentId/:keyCode',
    name: 'StakeholderUnsubscribe',
    component: StakeholderUnsubscribe
  },
  {
    path: '/close',
    name: 'Close',
    component: Close
  },
  {
    path: '/categoryMaintenance',
    name: 'CategoryMaintenance',
    component: CategoryMaintenance
  },
  {
    path: '/vendorCategoryMaintenance',
    name: 'VendorCategoryMaintenance',
    component: VendorCategoryMaintenance
  },
  {
    path: '/vendorAssessmentResult',
    name: 'VendorAssessmentResult',
    component: VendorAssessmentResult
  },
  {
    path: '/stakeholderQuestionnaireResult',
    name: 'StakeholderQuestionnaireResult',
    component: StakeholderQuestionnaireResult
  },
  {
    path: '/questionnaireResultDetail',
    name: 'QuestionnaireResultDetail',
    component: QuestionnaireResultDetail
  },
  {
    path: '/error404',
    name: 'Error404',
    component: Error404
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: ErrorPage
  },
  {
    path: '/coverPage',
    name: 'CoverPage',
    component: CoverPage
  },
  {
    path: '/cleanCache',
    name: 'CleanCache',
    component: CleanCache
  },
  {
    path: '/dictionaryMaintenance',
    name: 'DictionaryMaintenance',
    component: DictionaryMaintenance
  },
  {
    path: '/emailTemplateMaintenance',
    name: 'EmailTemplateMaintenance',
    component: EmailTemplateMaintenance
  },
  {
    path: '/adminUsersMaintenance',
    name: 'AdminUsersMaintenance',
    component: AdminUsersMaintenance
  },
  {
    path: '/rejectAccess',
    name: 'RejectAccess',
    component: RejectAccess
  },
  {
    path: '/networkError',
    name: 'NetworkError',
    component: NetworkError
  },
  {
    path: '/regionalAccountMaintenance',
    name: 'RegionalAccountMaintenance',
    component: RegionalAccountMaintenance
  },
  {
    path: '/maintLogView',
    name: 'MaintLogView',
    component: MaintLogView
  },
  {
    path: '/reportMaintenance',
    name: 'ReportMaintenance',
    component: ReportMaintenance
  }
];

const router = new Router({mode: 'history', routes}); // Remove # before url

router.beforeEach((to, from, next) => {
  // will redirect to 404 with wrong URL
  if (to.matched.length === 0) { // No match to routing
    from.name ? next({name: from.name}) : next('/error404');
  } else {
    // intercept page as API auth mix with ROLE_VENDOR
    if (to.name === 'VendorCategoryMaintenance' || to.name === 'VendorAssessment') {
      // load auth from service, temper proof cookie data
      verifyUserInfo().then((data) => {
        if (Constant.USER_TYPE_REGION_VENDOR === data.role) {
          next({name: 'AccessDenied'})
        }
      });
      next();
    } else if (to.name === 'CleanCache' || to.name === 'MaintLogView') {
      // there no security in spring for this page display
      // load auth from service, temper proof cookie data
      verifyUserInfo().then((data) => {
        if (Constant.USER_TYPE_ADMIN !== data.role) {
          next({name: 'AccessDenied'})
        }
        next();
      });
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js